import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon, SunIcon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
interface ThemeToggleProps {
  /** Use the active project brand's colours instead of the shell tokens. */
  branded?: boolean;
}
export function ThemeToggle({
  branded = false
}: ThemeToggleProps) {
  const {
    theme,
    toggleTheme
  } = useTheme();
  const isDark = theme === 'dark';
  return <button type="button" onClick={toggleTheme} role="switch" aria-checked={isDark} aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'} title={isDark ? 'Switch to light theme' : 'Switch to dark theme'} className={`relative inline-flex h-8 w-14 shrink-0 items-center rounded-full border transition focus:outline-none focus-visible:ring-2 ${branded ? 'border-[var(--b-border)] bg-[var(--b-surface-alt)] focus-visible:ring-[var(--b-accent)]' : 'border-shell-border bg-shell-surface-alt focus-visible:ring-accent'}`} data-id="element-171" data-mp="2pf9ukwdv3m82">
      <motion.span layout transition={{
      type: 'spring',
      stiffness: 500,
      damping: 34
    }} className="absolute flex h-6 w-6 items-center justify-center rounded-full" style={{
      left: isDark ? 4 : 'calc(100% - 28px)',
      backgroundColor: branded ? 'var(--b-accent)' : 'var(--s-accent)',
      color: branded ? 'var(--b-on-accent)' : 'var(--s-on-accent)'
    }} data-id="element-172" data-mp="1ga47dfg45c7f">
        {isDark ? <MoonIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-173" data-mp="skt4nsf7d7qn" /> : <SunIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-174" data-mp="ojr2b2pzofkg" />}
      </motion.span>
    </button>;
}